/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OemRateEntryInputDto
 */
export interface OemRateEntryInputDto {
    /**
     * 
     * @type {number}
     * @memberof OemRateEntryInputDto
     */
    windowValue: number;
    /**
     * 
     * @type {string}
     * @memberof OemRateEntryInputDto
     */
    windowUnit: OemRateEntryInputDtoWindowUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof OemRateEntryInputDto
     */
    costAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OemRateEntryInputDto
     */
    currency?: string;
}


/**
 * @export
 */
export const OemRateEntryInputDtoWindowUnitEnum = {
    Day: 'day',
    Hour: 'hour'
} as const;
export type OemRateEntryInputDtoWindowUnitEnum = typeof OemRateEntryInputDtoWindowUnitEnum[keyof typeof OemRateEntryInputDtoWindowUnitEnum];


/**
 * Check if a given object implements the OemRateEntryInputDto interface.
 */
export function instanceOfOemRateEntryInputDto(value: object): value is OemRateEntryInputDto {
    if (!('windowValue' in value) || value['windowValue'] === undefined) return false;
    if (!('windowUnit' in value) || value['windowUnit'] === undefined) return false;
    if (!('costAmount' in value) || value['costAmount'] === undefined) return false;
    return true;
}

export function OemRateEntryInputDtoFromJSON(json: any): OemRateEntryInputDto {
    return OemRateEntryInputDtoFromJSONTyped(json, false);
}

export function OemRateEntryInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OemRateEntryInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'windowValue': json['windowValue'],
        'windowUnit': json['windowUnit'],
        'costAmount': json['costAmount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function OemRateEntryInputDtoToJSON(json: any): OemRateEntryInputDto {
    return OemRateEntryInputDtoToJSONTyped(json, false);
}

export function OemRateEntryInputDtoToJSONTyped(value?: OemRateEntryInputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'windowValue': value['windowValue'],
        'windowUnit': value['windowUnit'],
        'costAmount': value['costAmount'],
        'currency': value['currency'],
    };
}

